<template>
  <div>
    <!-- 头部导航 -->
    <baseBack @font='font'></baseBack>
    <div v-for="(item,index) in list" :key="index" style="width: 350px; padding: 5px 10px ;background: #EBF1FF;border-radius: 10px;margin: 25px;" class="flex">
      <div @click="go(item,'精选题库')" style="margin: auto;" class="flex flex-col-center">
        <img src="../../assets/images/cateIcon.png" style="width: 47px;height:47px;" />
        <span style="color: #333333;font-size: 24px;">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      list: [
        {name: '三力测试 一'},
        {name: '三力测试 二'}
      ],
      car_type: '',
      subject: 0,
      navClassify: [
        {
          name: '科目一',
          id: 1
        },
        {
          name: '科目四',
          id: 4
        },
        {
          name: '注销恢复',
          id: 6
        },
        {
          name: '满分学习',
          id: 5
        }
      ]
    }
  },
  created() {
    // this.getClassify()
  },
  computed: {
    ...mapState(['font', 'carTypeParams'])
  },
  methods: {
    go(item, txt) {
      this.$Go('case', {
        id: item.id,
        txt: txt,
        car: this.carTypeParams.name,
        carId: this.car_type + 1,
        subject: item.name,
        subjectId: this.navClassify[this.subject].id
      })
    },
    // getClassify() {
    //   this.axios
    //     .post('/index/cate', {
    //       vip: 1
    //       // subject: subject,
    //       // car_type: this.car_type + 1
    //     })
    //     .then(res => {
    //       this.list = res[1].paper.slice(-2)
    //       console.log('这是',this.list);
    //     })
    //     .catch(error => {})
    // }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/threeTest/index.vue